import { motion } from "motion/react"

import { cn } from "@/lib/utils"
import { BRAND_NAME } from "@/lib/brand"

type Tone = "color" | "black" | "white"

type ToneColors = { hex: string; monogram: string }

const tones: Record<Tone, ToneColors> = {
  color: { hex: "#a80038", monogram: "#fbf9fa" },
  black: { hex: "#0a0a0a", monogram: "#fbf9fa" },
  white: { hex: "#fbf9fa", monogram: "#a80038" },
}

const HEXAGON_PATH =
  "M23.11 55.78L1.69 43.41A3.39 3.39 0 0 1 0 40.48V15.75a3.39 3.39 0 0 1 1.69-2.94L23.11.45a3.39 3.39 0 0 1 3.39 0l21.41 12.37a3.39 3.39 0 0 1 1.69 2.94v24.72a3.39 3.39 0 0 1-1.69 2.94L26.5 55.78a3.39 3.39 0 0 1-3.39 0z"

const MONOGRAM_PATH =
  "M8.8932 46.475 c-0.34383 0 -0.6864 -0.10383 -1.0517 -0.315 l-5.2511 -3.0354 c-0.7302 -0.4224 -1.0518 -0.9798 -1.0518 -1.8234 l0 -19.54 c0 -0.8436 0.32162 -1.401 1.0518 -1.8234 l5.5158 -3.1884 c0.23039 -0.13858 0.49981 -0.21838 0.7878 -0.21838 c0.8448 0 1.53 0.6852 1.53 1.53 c0 0.57598 -0.31858 1.0776 -0.78894 1.3386 l-5.037 2.9112 l0 18.439 l4.296 2.4828 l10.864 -6.2796 c0.23039 -0.13858 0.49981 -0.21838 0.7878 -0.21838 c0.8448 0 1.53 0.6852 1.53 1.53 c0 0.57598 -0.31858 1.0776 -0.78894 1.3386 l-11.34 6.555 c-0.36539 0.21117 -0.7092 0.31676 -1.0531 0.31676 z M8.8944 59.947148 l0.0032227 0.00058594 c-0.34383 0 -0.68766 -0.10559 -1.0531 -0.31676 l-5.2511 -3.0354 c-0.7302 -0.4224 -1.0506 -0.9798 -1.0517 -1.8234 l-0.0072072 -6.4086 c0 -0.8256 0.6858 -1.5222 1.5288 -1.5222 c0.25981 0 0.5226 0.065976 0.76374 0.20519 l5.0676 2.9238 l5.0382 -2.9124 c0.23039 -0.13858 0.49981 -0.21838 0.7878 -0.21838 c0.8448 0 1.53 0.6852 1.53 1.53 c0 0.57598 -0.31858 1.0776 -0.78894 1.3386 l-5.514 3.1872 c-0.36539 0.21117 -0.7092 0.31676 -1.0531 0.31676 s-0.68766 -0.10559 -1.0531 -0.31676 l-3.243 -1.8744 l0 3.2004 l4.296 2.4834 l10.121 -5.8506 l0 -5.8524 c0 -0.8448 0.6852 -1.53 1.53 -1.53 s1.53 0.6852 1.53 1.53 l0 6.4026 c0 0.8436 -0.32162 1.401 -1.0518 1.8174 l-11.077 6.4086 c-0.36539 0.21117 -0.7092 0.31676 -1.0531 0.31676 z M20.549 60.0023438 c-0.8448 0 -1.5325 -0.68694 -1.5325 -1.5317 c0 -0.57598 0.31858 -1.0776 0.78894 -1.3386 l5.037 -2.9112 l0 -18.439 l-4.296 -2.4828 l-5.0382 2.9118 c-0.22981 0.13858 -0.49922 0.21838 -0.7872 0.21838 c-0.8448 0 -1.53 -0.6852 -1.53 -1.53 c0 -0.57598 0.31858 -1.0776 0.78894 -1.3386 l5.514 -3.1872 c0.36539 -0.21117 0.7092 -0.31676 1.0531 -0.31676 s0.68766 0.10559 1.0531 0.31676 l5.2511 3.0354 c0.7308 0.4224 1.0524 0.9798 1.0524 1.8234 l0 19.54 c0 0.8436 -0.32162 1.401 -1.0518 1.8234 l-5.5158 3.1884 c-0.22981 0.13858 -0.49922 0.21838 -0.7872 0.21838 z M8.895 39.796 c-0.8448 0 -1.532 -0.68586 -1.532 -1.5307 l0 -6.4026 c0 -0.8436 0.32162 -1.401 1.0518 -1.8234 l11.077 -6.4026 c0.36539 -0.21117 0.7092 -0.31676 1.0531 -0.31676 s0.68766 0.10559 1.0531 0.31676 l3.243 1.8744 l0 -3.2004 l-4.296 -2.4834 l-10.864 6.2796 c-0.23039 0.13858 -0.49981 0.21838 -0.7878 0.21838 c-0.8448 0 -1.53 -0.6852 -1.53 -1.53 c0 -0.57598 0.31858 -1.0776 0.78894 -1.3386 l11.34 -6.555 c0.36539 -0.21117 0.7092 -0.31676 1.0531 -0.31676 s0.68766 0.10559 1.0531 0.31676 l5.2511 3.0354 c0.7308 0.4224 1.0524 0.9798 1.0524 1.8234 l0 6.9372 c0 0.8532 -0.37981 1.3289 -0.9696 1.3289 c-0.25318 0 -0.54539 -0.0876 -0.8628 -0.27117 l-5.523 -3.1926 l-10.121 5.8506 l0 5.8524 c0 0.8448 -0.6852 1.53 -1.53 1.53 z"

const WORDMARK_PATH =
  "M1.2 30.240000000000002 l4.04 0 c0.08 5.16 0.48 6.16 1.92 6.16 c1.96 0 1.96 -1.64 1.96 -6 c0 -6.4 -7.92 -4.68 -7.92 -13.2 c0 -5 0 -9.6 6 -9.6 c4.44 0 5.64 2.52 5.92 8.56 l-4 0 c-0.16 -4.36 -0.64 -5.36 -1.92 -5.36 c-1.96 0 -1.96 2.16 -1.96 6.4 c0 6.2 7.96 4 7.96 13.2 c0 5.6 0 10 -6.04 10 c-4.64 0 -5.72 -2.76 -5.96 -10.16 z M16.799999999999997 11.600000000000001 l0 -3.6 l12 0 l0 3.6 l-4 0 l0 28.4 l-4 0 l0 -28.4 l-4 0 z M33.2 40 l0 -32 l9.2 0 l0 3.2 l-5.2 0 l0 10.4 l4.4 0 l0 3.2 l-4.4 0 l0 11.2 l5.2 0 l0 4 l-9.2 0 z M47.2 40 l0 -32 l4 0 l0 32 l-4 0 z M57.2 40 l0 -32 l3.6 0 l4.2 20 l0.4 0 l4.2 -20 l3.6 0 l0 32 l-4 0 l0 -16 l-2.84 16 l-2.4 0 l-2.76 -16 l0 16 l-4 0 z M79.2 40 l0 -32 l8.4 0 l0 3.2 l-4.4 0 l0 12 l3.6 0 l0 3.2 l-3.6 0 l0 13.6 l-4 0 z M92.4 40 l0 -32 l4 0 l0 32 l-4 0 z M100.80000000000001 11.600000000000001 l0 -3.6 l12 0 l0 3.6 l-4 0 l0 28.4 l-4 0 l0 -28.4 l-4 0 z"

const TAGLINE_PATH =
  "M7.68 6.460000000000001 l-3.1 0 l0 13.54 l-1.48 0 l0 -13.54 l-3.1 0 l0 -1.46 l7.68 0 l0 1.46 z M21.140500000000003 20 l-1.72 -0.000019531 l-3.14 -6.06 l-2.6 0 l0 6.06 l-1.34 0 l0 -15 l3.44 0 c1.3733 0 2.46 0.39334 3.26 1.18 s1.2 1.8667 1.2 3.24 c0 0.42666 -0.05666 0.86 -0.17 1.3 s-0.27668 0.85334 -0.49002 1.24 s-0.47668 0.73666 -0.79002 1.05 s-0.67 0.55668 -1.07 0.73002 z M18.820500000000003 9.32 c0 -0.46666 -0.08 -0.88664 -0.24 -1.26 s-0.38 -0.69 -0.66 -0.95 s-0.61334 -0.46 -1 -0.6 s-0.80666 -0.21 -1.26 -0.21 l-1.98 0 l0 6.26 l2.1 0 c1.0667 0 1.84 -0.28666 2.32 -0.86 s0.72 -1.3667 0.72 -2.38 z M33.081 20 l-7.5 0 l0 -15 l7.36 0 l0 1.52 l-5.98 0 l0 5.16 l5.94 0 l0 1.3 l-5.94 0 l0 5.5 l6.12 0 l0 1.52 z M39.3415 20 l-1.5 0 l0 -15 l1.5 0 l0 15 z M52.622 20 l-1.56 0 l-5.2 -11.8 l0 11.8 l-1.44 0 l0 -15 l1.44 0 l5.22 11.3 l0.12 -11.3 l1.42 0 l0 15 z M66.4625 20 l-1.4 0 l-1.06 -4.3 l-4.36 0 l-1.06 4.3 l-1.36 0 l4.06 -15 l1.14 0 z M63.6625 14.36 l-1.78 -7.42 l-1.9 7.42 l3.68 0 z M80.963 20 l-1.34 0 l0 -11.58 l-3.14 7.62 l-1.36 -0.02 l-3.06 -7.6 l0 11.58 l-1.34 0 l0 -15 l1.34 0 l3.76 9.18 l3.8 -9.18 l1.34 0 l0 15 z M93.8035 20 l-7.5 0 l0 -15 l7.36 0 l0 1.52 l-5.98 0 l0 5.16 l5.94 0 l0 1.3 l-5.94 0 l0 5.5 l6.12 0 l0 1.52 z M106.564 20 l-1.56 0 l-5.2 -11.8 l0 11.8 l-1.44 0 l0 -15 l1.44 0 l5.22 11.3 l0.12 -11.3 l1.42 0 l0 15 z M118.86449999999999 6.460000000000001 l-3.1 0 l0 13.54 l-1.48 0 l0 -13.54 l-3.1 0 l0 -1.46 l7.68 0 l0 1.46 z M130.705 16.12 c0 1.4133 -0.31666 2.4434 -0.95 3.09 s-1.6633 0.97 -3.09 0.97 c-1.3067 0 -2.2634 -0.36 -2.87 -1.08 s-0.91 -1.7133 -0.91 -2.98 l0 -7.2 c0 -1.3733 0.32334 -2.3934 0.97 -3.06 s1.6633 -1 3.05 -1 c1.32 0 2.2834 0.35 2.89 1.05 s0.91 1.69 0.91 2.97 l0 7.24 z M129.305 16.08 l-0.000019531 -7.22 c0 -0.76 -0.2 -1.3933 -0.6 -1.9 s-1.0067 -0.76 -1.82 -0.76 c-0.97334 0 -1.65 0.25334 -2.03 0.76 s-0.57 1.22 -0.57 2.14 l0 6.9 c0 0.38666 0.04334 0.75 0.13 1.09 s0.22666 0.63666 0.42 0.89 s0.44 0.45334 0.74 0.6 s0.66334 0.22 1.09 0.22 c0.93334 0 1.6067 -0.22666 2.02 -0.68 s0.62 -1.1333 0.62 -2.04 z M150.526 9.8 c0 0.66666 -0.10662 1.2867 -0.31996 1.86 s-0.51334 1.07 -0.9 1.49 s-0.86 0.75 -1.42 0.99 s-1.18 0.36 -1.86 0.36 l-1.86 0 l0 5.5 l-1.5 0 l0 -15 l3.64 0 c0.73334 0 1.3633 0.12334 1.89 0.37 s0.96332 0.58332 1.31 1.01 s0.60332 0.93332 0.76998 1.52 s0.25 1.22 0.25 1.9 z M149.006 9.76 c0 -1.08 -0.22334 -1.91 -0.67 -2.49 s-1.25 -0.87 -2.41 -0.87 l-1.76 0 l0 6.64 l1.56 0 c1.08 0 1.8967 -0.28 2.45 -0.84 s0.83 -1.3733 0.83 -2.44 z M162.7265 20 l-7.5 0 l0 -15 l7.36 0 l0 1.52 l-5.98 0 l0 5.16 l5.94 0 l0 1.3 l-5.94 0 l0 5.5 l6.12 0 l0 1.52 z M175.987 20 l-1.72 -0.000019531 l-3.14 -6.06 l-2.6 0 l0 6.06 l-1.34 0 l0 -15 l3.44 0 c1.3733 0 2.46 0.39334 3.26 1.18 s1.2 1.8667 1.2 3.24 c0 0.42666 -0.05666 0.86 -0.17 1.3 s-0.27668 0.85334 -0.49002 1.24 s-0.47668 0.73666 -0.79002 1.05 s-0.67 0.55668 -1.07 0.73002 z M173.66699999999997 9.32 c0 -0.46666 -0.08 -0.88664 -0.24 -1.26 s-0.38 -0.69 -0.66 -0.95 s-0.61334 -0.46 -1 -0.6 s-0.80666 -0.21 -1.26 -0.21 l-1.98 0 l0 6.26 l2.1 0 c1.0667 0 1.84 -0.28666 2.32 -0.86 s0.72 -1.3667 0.72 -2.38 z M188.02749999999997 16.12 c0 1.2267 -0.3199 2.21 -0.9599 2.95 s-1.5933 1.11 -2.86 1.11 c-0.74666 0 -1.3767 -0.10666 -1.89 -0.32 s-0.93 -0.52 -1.25 -0.92 s-0.55 -0.88 -0.69 -1.44 s-0.20334 -1.1867 -0.19 -1.88 l0.02 -0.52 l1.54 0 c0 0.42666 0.01334 0.86332 0.04 1.31 s0.11332 0.85332 0.25998 1.22 s0.37332 0.66666 0.67998 0.9 s0.74666 0.35 1.32 0.35 c0.88 0 1.5267 -0.23334 1.94 -0.7 s0.62 -1.12 0.62 -1.96 c0 -0.66666 -0.16 -1.1933 -0.48 -1.58 s-0.72 -0.71332 -1.2 -0.97998 s-0.99666 -0.50666 -1.55 -0.72 s-1.07 -0.48 -1.55 -0.8 s-0.88 -0.73 -1.2 -1.23 s-0.48 -1.1633 -0.48 -1.99 c0 -1.3333 0.34334 -2.3434 1.03 -3.03 s1.6967 -1.03 3.03 -1.03 c0.62666 0 1.17 0.1 1.63 0.3 s0.84334 0.48 1.15 0.84 s0.53332 0.78666 0.67998 1.28 s0.22 1.04 0.22 1.64 l0 1.26 l-1.46 0 c0 -0.44 -0.0033398 -0.89666 -0.01 -1.37 s-0.07666 -0.90668 -0.21 -1.3 s-0.35668 -0.71668 -0.67002 -0.97002 s-0.77 -0.38 -1.37 -0.38 c-0.86666 0 -1.52 0.22 -1.96 0.66 s-0.64666 1.0867 -0.62 1.94 l0 0.2 c0.01334 0.41334 0.08334 0.75668 0.21 1.03 s0.3 0.50668 0.52 0.70002 s0.47666 0.36334 0.77 0.51 s0.61334 0.3 0.96 0.46 c0.50666 0.22666 1 0.46666 1.48 0.72 s0.90334 0.55 1.27 0.89 s0.66332 0.74 0.88998 1.2 s0.34 1.01 0.34 1.65 z M200.44799999999998 16.12 c0 1.4133 -0.31666 2.4434 -0.95 3.09 s-1.6633 0.97 -3.09 0.97 c-1.3067 0 -2.2634 -0.36 -2.87 -1.08 s-0.91 -1.7133 -0.91 -2.98 l0 -7.2 c0 -1.3733 0.32334 -2.3934 0.97 -3.06 s1.6633 -1 3.05 -1 c1.32 0 2.2834 0.35 2.89 1.05 s0.91 1.69 0.91 2.97 l0 7.24 z M199.04799999999997 16.08 l-0.000019531 -7.22 c0 -0.76 -0.2 -1.3933 -0.6 -1.9 s-1.0067 -0.76 -1.82 -0.76 c-0.97334 0 -1.65 0.25334 -2.03 0.76 s-0.57 1.22 -0.57 2.14 l0 6.9 c0 0.38666 0.04334 0.75 0.13 1.09 s0.22666 0.63666 0.42 0.89 s0.44 0.45334 0.74 0.6 s0.66334 0.22 1.09 0.22 c0.93334 0 1.6067 -0.22666 2.02 -0.68 s0.62 -1.1333 0.62 -2.04 z M213.5685 20 l-1.56 0 l-5.2 -11.8 l0 11.8 l-1.44 0 l0 -15 l1.44 0 l5.22 11.3 l0.12 -11.3 l1.42 0 l0 15 z M227.40900000000002 20 l-1.4 0 l-1.06 -4.3 l-4.36 0 l-1.06 4.3 l-1.36 0 l4.06 -15 l1.14 0 z M224.609 14.36 l-1.78 -7.42 l-1.9 7.42 l3.68 0 z M237.8495 20 l-6.18 0 l0 -15 l1.4 0 l0 13.56 l4.78 0 l0 1.44 z M243.82999999999998 20 l-1.5 0 l0 -15 l1.5 0 l0 15 z M256.71049999999997 20 l-7.8 0 l0 -1.98 l6.46 -11.54 l-6.46 0 l0 -1.48 l7.8 0 l0 1.98 l-6.42 11.54 l6.42 0 l0 1.48 z M270.15099999999995 20 l-1.4 0 l-1.06 -4.3 l-4.36 0 l-1.06 4.3 l-1.36 0 l4.06 -15 l1.14 0 z M267.35099999999994 14.36 l-1.78 -7.42 l-1.9 7.42 l3.68 0 z M282.01149999999996 12.18 c0 0.49334 0.0033984 1.03 0.010059 1.61 s-0.01668 1.16 -0.07002 1.74 s-0.15 1.14 -0.29 1.68 s-0.35666 1.0167 -0.65 1.43 s-0.67668 0.74334 -1.15 0.99 s-1.0633 0.37 -1.77 0.37 l-3.64 0 l0 -15 l3.5 0 c0.73334 0 1.34 0.10334 1.82 0.31 s0.87334 0.48666 1.18 0.84 s0.53332 0.76668 0.67998 1.24 s0.24666 0.97668 0.3 1.51 s0.08 1.08 0.08 1.64 l0 1.64 z M280.65149999999994 12.32 l0.000019531 -0.85996 c0 -0.37334 -0.01 -0.76 -0.03 -1.16 s-0.04666 -0.78 -0.08 -1.14 s-0.07668 -0.62666 -0.13002 -0.8 c-0.22666 -0.66666 -0.54 -1.16 -0.94 -1.48 s-0.96 -0.48 -1.68 -0.48 l-2 0 l0 12.16 l2.26 0 c0.29334 0 0.56 -0.05334 0.8 -0.16 s0.46 -0.25 0.66 -0.43 s0.37 -0.38666 0.51 -0.62 s0.25666 -0.47668 0.35 -0.73002 c0.06666 -0.17334 0.11666 -0.45668 0.15 -0.85002 s0.06 -0.81 0.08 -1.25 s0.03334 -0.86334 0.04 -1.27 s0.01 -0.71666 0.01 -0.93 z M294.65199999999993 16.12 c0 1.4133 -0.31666 2.4434 -0.95 3.09 s-1.6633 0.97 -3.09 0.97 c-1.3067 0 -2.2634 -0.36 -2.87 -1.08 s-0.91 -1.7133 -0.91 -2.98 l0 -7.2 c0 -1.3733 0.32334 -2.3934 0.97 -3.06 s1.6633 -1 3.05 -1 c1.32 0 2.2834 0.35 2.89 1.05 s0.91 1.69 0.91 2.97 l0 7.24 z M293.25199999999995 16.08 l-0.000019531 -7.22 c0 -0.76 -0.2 -1.3933 -0.6 -1.9 s-1.0067 -0.76 -1.82 -0.76 c-0.97334 0 -1.65 0.25334 -2.03 0.76 s-0.57 1.22 -0.57 2.14 l0 6.9 c0 0.38666 0.04334 0.75 0.13 1.09 s0.22666 0.63666 0.42 0.89 s0.44 0.45334 0.74 0.6 s0.66334 0.22 1.09 0.22 c0.93334 0 1.6067 -0.22666 2.02 -0.68 s0.62 -1.1333 0.62 -2.04 z"

export function BrandMark({
  tone = "color",
  className,
  title = BRAND_NAME,
}: {
  tone?: Tone
  className?: string
  title?: string
}) {
  const { hex, monogram } = tones[tone]
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="100 170 1330 1330"
      role="img"
      aria-label={title}
      className={cn("shrink-0", className)}
    >
      <g transform="scale(8.174386920980927) translate(10, 10)">
        <g
          transform="matrix(2.5560852997962904,0,0,2.5560852997962904,20.000018807798714,20.01066793863929)"
          fill={hex}
        >
          <path d={HEXAGON_PATH} />
        </g>
        <g
          transform="matrix(2.123692236962225,0,0,2.123692236962225,51.741162863989025,10.893202832917865)"
          fill={monogram}
        >
          <path d={MONOGRAM_PATH} />
        </g>
      </g>
    </svg>
  )
}

// Just the "S" monogram (no hexagon), in currentColor so callers can tint it.
// Rendered in the monogram path's own coordinate space; the viewBox is the
// path's exact bounding box (+1 unit padding) so the glyph fills the box.
export function BrandMonogram({
  className,
  title = BRAND_NAME,
}: {
  className?: string
  title?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0.53 15.53 28.37 45.47"
      role="img"
      aria-label={title}
      className={cn("shrink-0", className)}
    >
      <path d={MONOGRAM_PATH} fill="currentColor" />
    </svg>
  )
}

type LockupSize = "sm" | "md" | "lg"

const lockupHeights: Record<LockupSize, string> = {
  sm: "h-8",
  md: "h-12",
  lg: "h-24",
}

export function BrandLockup({
  size = "md",
  showTagline = false,
  animate = false,
  className,
}: {
  size?: LockupSize
  showTagline?: boolean
  animate?: boolean
  className?: string
}) {
  const MarkG = animate ? motion.g : "g"
  const markProps = animate
    ? {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        transition: { duration: 0.5, ease: "easeOut" as const },
      }
    : {}
  const wordmarkProps = animate
    ? {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        transition: { duration: 0.4, delay: 0.2, ease: "easeOut" as const },
      }
    : {}
  const taglineProps = animate
    ? {
        initial: { opacity: 0 },
        animate: { opacity: 0.7 },
        transition: { duration: 0.3, delay: 0.4, ease: "easeOut" as const },
      }
    : {}

  const Wrapper = animate ? motion.svg : "svg"
  const wrapperProps = animate
    ? {
        initial: { opacity: 0, scale: 0.96 },
        animate: { opacity: 1, scale: 1 },
        transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] as const },
        style: { transformOrigin: "center" },
      }
    : {}

  return (
    <Wrapper
      xmlns="http://www.w3.org/2000/svg"
      viewBox="220 240 2860 1180"
      role="img"
      aria-label={BRAND_NAME}
      preserveAspectRatio="xMidYMid meet"
      className={cn("shrink-0 w-auto", lockupHeights[size], className)}
      {...wrapperProps}
    >
      <g transform="scale(8.174386920980927) translate(10, 10)">
        <MarkG
          transform="matrix(2.5560852997962904,0,0,2.5560852997962904,20.000018807798714,20.01066793863929)"
          fill="#a80038"
          {...markProps}
        >
          <path d={HEXAGON_PATH} />
        </MarkG>
        <MarkG
          transform="matrix(2.123692236962225,0,0,2.123692236962225,51.741162863989025,10.893202832917865)"
          fill="#fbf9fa"
          {...markProps}
        >
          <path d={MONOGRAM_PATH} />
        </MarkG>
        {animate ? (
          <motion.g
            transform="matrix(1.792114597327962,0,0,1.792114597327962,164.84946282502517,48.86427)"
            fill="currentColor"
            {...wordmarkProps}
          >
            <path d={WORDMARK_PATH} />
          </motion.g>
        ) : (
          <g
            transform="matrix(1.792114597327962,0,0,1.792114597327962,164.84946282502517,48.86427)"
            fill="currentColor"
          >
            <path d={WORDMARK_PATH} />
          </g>
        )}
        {showTagline &&
          (animate ? (
            <motion.g
              transform="matrix(0.543013438310739,0,0,0.543013438310739,167,119.36095409945172)"
              fill="currentColor"
              {...taglineProps}
            >
              <path d={TAGLINE_PATH} />
            </motion.g>
          ) : (
            <g
              transform="matrix(0.543013438310739,0,0,0.543013438310739,167,119.36095409945172)"
              fill="currentColor"
              opacity="0.7"
            >
              <path d={TAGLINE_PATH} />
            </g>
          ))}
      </g>
    </Wrapper>
  )
}
